import { defineComponent as t, createElementBlock as n, openBlock as o, createElementVNode as a, renderSlot as r } from "vue";
const s = { class: "flex justify-center" }, l = {
  class: "max-w-full grow px-24 lg:max-w-[1184px] lg:basis-full lg:px-32",
  "data-test": "container-wrapper"
}, _ = /* @__PURE__ */ t({
  name: "RevContainer",
  __name: "Container",
  setup(c) {
    return (e, i) => (o(), n("div", s, [
      a("div", l, [
        r(e.$slots, "default")
      ])
    ]));
  }
});
export {
  _ as default
};
